import React from "react";
import BilleteraForm from "../../components/BilleteraForm";
import Navbar from "../../components/Navbar";

const Venta = () => {
  return (
    <div className="container">
      <Navbar />

      <BilleteraForm />
    </div>
  );
};

export default Venta;
